// team 團隊介紹
import { TEAM_CONTENT } from "../common/constant";
import CRTeamSwiperWrap from "./CRTeamSwiperWrap";

const CRTeam = () => {
    return(
        <section id="cr-team" className="cr-section cr-team w-full h-full 
            bg-black text-white text-center z-10 
            mt-[75px] pt-[145px] pb-[145px] px-[16px] 
            asm:min-h-[750px] asm:h-screen
            bsm:mt-[70vw] usx:mt-[90vw] usm:pt-[60px]
            pointer-events-none
        ">
            <p className="text-russo text-[36px] font-400 leading-[200%] tracking-[1.3px]">{TEAM_CONTENT[0]}</p>
            <p className="text-bd5n mb-[16px]">{TEAM_CONTENT[1]}</p>
            <p className="text-black2 text-bd1n mb-[40px]" >{TEAM_CONTENT[2]}</p>

            <div className="team-container m-auto w-full max-w-[1256px] h-[fit-content] center-center flex flex-nowrap items-baseline usm:gap-x-[10px] overflow-hidden">
                <CRTeamSwiperWrap />
            </div>
            <div className="white-dot bg-white rounded-[500%] w-[10px] h-[10px] absolute left-0 right-0 bottom-0 m-auto max-h-[screen] overflow-hidden"></div>
        </section>
    )
}

export default CRTeam;